import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useTextOverflow from "../../../hooks/useTextOverflow";
import { TooltipProps } from "../../../helpers/materialUITheme";

const RenderListItem = ({ item, setSelectedObjectId, setOpenObjectDialog }) => {
  const [textRef, isOverflowed] = useTextOverflow();

  return (
    <Tooltip title={isOverflowed ? item.name : ""} componentsProps={TooltipProps} placement="right" arrow>
      <Typography
        ref={textRef}
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        onClick={() => {
          setSelectedObjectId(item.protectionObjectId);
          setOpenObjectDialog(true);
        }}
        className="organization-object-table__row-item-link"
      >
        {item.name}
      </Typography>
    </Tooltip>
  );
};

export const MoreObjectDialog = ({ open, setOpen, selectedObjectList, setSelectedObjectId, setOpenObjectDialog, selectedName }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} className="object_dialog" maxWidth="lg" sx={{ minWidth: "1100px", padding: "0px" }}>
      <DialogTitle sx={{ display: "flex", gap: "10px", justifyContent: "space-between", padding: "0" }}>
        <Typography className="modal-title">Объекты привязанные к пульту: {selectedName}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "0px" }}>
        <Box className="organization-object-table">
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderBottom: "1px solid #cfd9e8" }}>
            <Box className="organization-object-table__header-item">Объект</Box>
            <Box className="organization-object-table__header-item">Пультовый номер</Box>
          </Box>
          {selectedObjectList.map((item) => (
            <Box
              key={item.id}
              sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderBottom: "1px solid #cfd9e8" }}
            >
              <RenderListItem
                item={item}
                setSelectedObjectId={setSelectedObjectId}
                setOpenObjectDialog={setOpenObjectDialog}
              />
              <Box className="organization-object-table__row-item">{item.integrationNumber}</Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
